import React, { FC } from 'react';
import styled from '@emotion/styled';
import Icon from '~ComponentsImproved/Icon';
import babyChangingStationIcon from '~Assets/icons/FloorplanObstacles/baby_changing_station.svg';
import chefHatIcon from '~Assets/icons/FloorplanObstacles/chef_hat.svg';
import coffeeMakerIcon from '~Assets/icons/FloorplanObstacles/coffee_maker.svg';
import doorOpenIcon from '~Assets/icons/FloorplanObstacles/door_open.svg';
import exitIcon from '~Assets/icons/FloorplanObstacles/exit.svg';
import fireExtinguisherIcon from '~Assets/icons/FloorplanObstacles/fire_extinguisher.svg';
import liveTvIcon from '~Assets/icons/FloorplanObstacles/live_tv.svg';
import localBarIcon from '~Assets/icons/FloorplanObstacles/local_bar.svg';
import musicNoteIcon from '~Assets/icons/FloorplanObstacles/music_note.svg';
import natureIcon from '~Assets/icons/FloorplanObstacles/nature.svg';
import nightlifeIcon from '~Assets/icons/FloorplanObstacles/nightlife.svg';
import noDrinksIcon from '~Assets/icons/FloorplanObstacles/no_drinks.svg';
import noMealsIcon from '~Assets/icons/FloorplanObstacles/no_meals.svg';
import parkIcon from '~Assets/icons/FloorplanObstacles/park.svg';
import pottedPlantIcon from '~Assets/icons/FloorplanObstacles/potted_plant.svg';
import smokeFreeIcon from '~Assets/icons/FloorplanObstacles/smoke_free.svg';
import smokeRoomIcon from '~Assets/icons/FloorplanObstacles/smoke_room.svg';
import sportsBarIcon from '~Assets/icons/FloorplanObstacles/sports_bar.svg';
import stairsIcon from '~Assets/icons/FloorplanObstacles/stairs.svg';
import wcIcon from '~Assets/icons/FloorplanObstacles/wc.svg';
import pointOfSaleIcon from '~Assets/icons/FloorplanObstacles/point_of_sale.svg';
import checkroomIcon from '~Assets/icons/FloorplanObstacles/checkroom.svg';
import { HANDY_SCALE_FACTOR } from '~Scenes/Handy/Scenes/TableSelector/TableLayout/TableMap/constants';

const Wrapper = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  z-index: 2;
`;

const ICON_MAP: Record<string, string> = {
  baby_changing_station: babyChangingStationIcon,
  chef: chefHatIcon,
  kitchen: chefHatIcon,
  coffee: coffeeMakerIcon,
  door: doorOpenIcon,
  exit: exitIcon,
  fire_extinguisher: fireExtinguisherIcon,
  tv: liveTvIcon,
  bar: localBarIcon,
  music: musicNoteIcon,
  nature: natureIcon,
  nightlife: nightlifeIcon,
  no_drinks: noDrinksIcon,
  no_meals: noMealsIcon,
  park: parkIcon,
  plant: pottedPlantIcon,
  no_smoking: smokeFreeIcon,
  smoking: smokeRoomIcon,
  sports_bar: sportsBarIcon,
  stairs: stairsIcon,
  wc: wcIcon,
  pos: pointOfSaleIcon,
  checkroom: checkroomIcon,
};

interface Props {
  icon: string; // Icon key to map to an SVG
  size: number; // 30, 40, or 50
  isHandy?: boolean; // If true, scale down the size for mobile devices
}

/** Marker is an icon displayed in the floor plan to visualize points of interest, such as toilets */
const Marker: FC<Props> = ({ icon, size, isHandy = false }) => {
  // Apply the same scaling factor as tables on handy devices (0.8421)
  const scaledSize = isHandy ? size * HANDY_SCALE_FACTOR : size;

  return (
    <Wrapper size={scaledSize}>
      <Icon
        src={ICON_MAP[icon]}
        width={`${scaledSize}px`}
        height={`${scaledSize}px`}
        color="var(--colorBlueGray800)"
        center
      />
    </Wrapper>
  );
};

export default Marker;
